// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend) // Dùng để tải file JSON ngôn ngữ từ thư mục public
  .use(initReactI18next) // Kết nối i18next với React
  .init({
    fallbackLng: 'vi', // Ngôn ngữ mặc định nếu có lỗi
    supportedLngs: ['vi', 'en'], // Các ngôn ngữ bạn hỗ trợ
    interpolation: {
      escapeValue: false, // React đã có cơ chế chống XSS
    },
    backend: {
      // Đường dẫn đến các file ngôn ngữ
      loadPath: '/locales/{{lng}}/translation.json',
    },
  });

export default i18n;